import { Link } from 'react-router-dom';
import { PILLARS } from '../constants/content';

export default function Pillars() {
  return (
    <section className="fm-section" id="pillars">
      <div className="fm-container">
        <div className="fm-sec-head fm-sec-head--wide">
          <p className="fm-kicker">What we offer</p>
          <h2 className="fm-sec-title">
            Everything your team needs to create and grow
          </h2>
          <p className="fm-sec-lead">
            GearsZone brings creative software and digital marketing tools
            together so designers and marketers can work from one trusted store.
          </p>
        </div>

        <div className="fm-pillar-grid">
          {PILLARS.map((pillar) => (
            <article key={pillar.id} className="fm-pillar">
              <p className="fm-pillar__eyebrow">{pillar.eyebrow}</p>
              <h3>{pillar.title}</h3>
              <p className="fm-pillar__text">{pillar.text}</p>
              <ul>
                {pillar.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <Link className="fm-btn fm-btn--outline" to={pillar.cta.href}>
                {pillar.cta.label}
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
